import { FormlyFieldConfig } from "@ngx-formly/core";
import { AllegatiBolliAltroStep } from "../../shared/allegati-bolli-altro.step";
export const OccupazioneManifestazioneStep : FormlyFieldConfig[] =
    [
        {
            "fieldGroup": [
                {
                    "wrappers": ['group-panel'],
                    "key": 'jd.elementi_occupazione',
                    "defaultValue":[null],
                    "type": 'repeat',
                    "fieldGroupClassName": "flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 mt-4 w-full",
                    "props": {
                        "addText": '+ AGGIUNGI ELEMENTO',
                        "label": 'ELENCO ELEMENTI DI OCCUPAZIONE SUOLO PER MANIFESTAZIONE',
                        "required": true
                    },
                    "fieldArray": {
                        "fieldGroup": [
                            {
                                "fieldGroupClassName": 'border border-t-4 p-4 shadow-sm rounded-xl mb-2 grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-6 gap-4 sm:w-full',
                                "fieldGroup": [
                                    {
                                        "className": 'sm:col-span-1 md:col-span-6',
                                        "key": 'tipologia',
                                        "type": 'mat-select',
                                        "props": {
                                            "label": "TIPO DI TARIFFA",
                                            "required": true,
                                            "options": [
                                                { value: 1, label: 'MANIFESTAZIONI POLITICO, CULTURALE, SOCIALE, SPORTIVO,SINDACALE, RELIGIOSO' },
                                                { value: 2, label: 'SPETTACOLO VIAGGIANTE (SENZA INSTALLAZIONI)' },
                                                { value: 3, label: 'SPETTACOLO VIAGGIANTE (CON INSTALLAZIONI)' },
                                                { value: 4, label: 'FIERE' },
                                                { value: 5, label: 'ESPOSIZIONE MERCE' },
                                                { value: 6, label: 'SOSTA AUTOCARRO' },
                                                { value: 7, label: 'OCCUPAZIONE SUOLO' },
                                                { value: 8, label: 'TAVOLI E SEDIE - DEHOR TEMPORANEI (MAX 15mq)' },
                                                { value: 9, label: 'TAVOLI E SEDIE A TARIFFAZIONE - DEHOR TEMPORANEI (MAX 15mq)' },
                                                { value: 10, label: 'SPAZI SOPRASTANTI' }
                                            ],
                                            change: (field) => field.parent.get(`${field.key}_value`).formControl.setValue(((field.props.options as Array<{ value: any; label: string }>).filter((x) => x.value == field.formControl.value))[0].label),
                                    },
                                    },
                                    {
                                        key: 'tipologia_value'
                                    },
                                    {
                                        "className": 'sm:col-span-1 md:col-span-3',
                                        "key": 'elemento',
                                        type: 'mat-select',
                                        "props": {
                                            "label": "ELEMENTO DI OCCUPAZIONE",
                                            "required": true,
                                            "options": [
                                                { value: 1, label: 'MANIFESTAZIONE' }
                                            ],
                                        },
                                    },
                                    {
                                        "className": 'sm:col-span-1 md:col-span-3',
                                        "key": 'via',
                                        type: 'mat-autocomplete',
                                        "props": {
                                            "label": 'VIA',
                                            "required": true,
                                        },
                                        "validation": {
                                            "show": true,
                                        },
                                        validators:{
                                            validation:['AutocompleteMatch'],
                                        },
                                        hooks: {
                                            onInit: (field) => field.props.filter = (term: string) => field.options.formState.cmp._ubicazioneService.getViaByTerm(term)
                                        },
                                    },
                                    {
                                        "className": 'sm:col-span-1 md:col-span-2',
                                        "key": 'lunghezza',
                                        type: 'mat-input',
                                        "props": {
                                            "label": 'LUNGHEZZA (m)',
                                            "required": true,
                                            "type": 'number'
                                        },
                                    },
                                    {
                                        "className": 'sm:col-span-1 md:col-span-2',
                                        "key": 'larghezza',
                                        type: 'mat-input',
                                        "props": {
                                            "label": 'LARGHEZZA (m)',
                                            "required": true,
                                            "type": 'number'
                                        },
                                    },
                                    {
                                        "className": 'sm:col-span-1 md:col-span-2',
                                        "key": 'altezza',
                                        type:'mat-input',
                                        "props": {
                                            "label": 'ALTEZZA (m)',
                                            "required": true,
                                            "type": 'number'
                                        },
                                    },
                                    {
                                        "className": 'sm:col-span-1 md:col-span-3',
                                        "key": 'ml_giornalieri',
                                        type: 'mat-input',
                                        "props": {
                                            "label": ' METRI LINEARI DI OCCUPAZIONE GIORNALIERA',
                                            "required": true,
                                            "type": 'number'
                                        },
                                    },
                                    {
                                        "className": 'sm:col-span-1 md:col-span-3',
                                        "key": 'durata',
                                        type: 'mat-input',
                                        defaultValue:'',
                                        "props": {
                                            "label": 'DURATA (giorni)',
                                            "description": 'INDICARE LA DURATA SOLO SE SI TRATTA DI NUMERO DI GIORNI DIVERSI DA QUELLO INDICATO NELLA PRATICA',
                                        },
                                    },
                                    {
                                        "className": 'sm:col-span-1 md:col-span-6',
                                        "key": 'descrizione',
                                        "type":'mat-textarea',
                                        "props": {
                                            "label": "INDICARE POSIZIONE ESATTA (UBICAZIONE DA CIVICO A CIVICO) E COSA SI OCCUPA (CARREGGIATA, STALLO DI SOSTA, AREA PEDONALE, ...)",
                                            "autosize": true,
                                            "required": true,
                                            "autosizeMaxRows": 8,
                                            "autosizeMinRows": 2
                                        },
                                    },
                                ],
                            }
                        ],
                    }
                },
            ],
        },
                ...AllegatiBolliAltroStep
    ]

